<template>
  <div class="my-2 text-caption" data-testid="zahlungsdeckung">
    <span v-if="!settlement" class="grey--text">Offener Betrag wird geladen.</span>
    <template v-else>
      <div v-if="settlement.state === 'no_receivables'">Keine konkrete Forderung vorhanden.</div>
      <div v-else>
        <span v-if="!veralteterStand && !konflikte.length && (settlement.settled || settlement.state === 'settled')" class="success--text">
          Beglichen · offen: {{ betrag(0) }}
        </span>
        <span v-else-if="Number(settlement.openAmountMinor) > 0" class="warning--text">
          Offen: {{ betrag(settlement.openAmountMinor) }}
        </span>
        <span v-else class="warning--text">Zahlungsangaben prüfen</span>
        <span v-if="!belegsumme && Number(settlement.paidAmountMinor) !== 0">
          · Zugeordnet: {{ betrag(settlement.paidAmountMinor) }}
        </span>
      </div>
      <div v-if="belegsumme && settlement.invoiceAmountMinor !== undefined" class="grey--text">
        Rechnungen: {{ betrag(settlement.invoiceAmountMinor) }}
        · Buchungsbelege: {{ betrag(settlement.receiptAmountMinor) }}
        · Ohne Upload bestätigt: {{ betrag(settlement.manualPaidAmountMinor) }}
      </div>
      <div v-if="Number(settlement.overpaidAmountMinor) > 0" class="warning--text">
        Guthaben: {{ betrag(settlement.overpaidAmountMinor) }}
      </div>
      <div v-if="veralteterStand || settlement.state === 'conflict' || konflikte.length" class="error--text">
        Zahlungsstatus prüfen: {{ konflikte.map(konfliktText).join(' · ') || 'Neuberechnung erforderlich' }}
      </div>
      <div v-if="!belegsumme && settlement.unallocatedBankAmounts && settlement.unallocatedBankAmounts.length" class="warning--text">
        {{ settlement.unallocatedBankAmounts.length }} Bankbetrag/-beträge sind keiner Rechnung eindeutig zugeordnet.
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    settlement: { type: Object, default: null },
  },
  computed: {
    konflikte() { return (this.settlement && this.settlement.conflicts) || []; },
    belegsumme() { return this.settlement && this.settlement.calculationMethod === 'document_balance'; },
    // Der Server liefert den Saldo frisch. Ein abweichender gespeicherter
    // Abschluss-Snapshot ist keine offene Zahlung und erfordert keine Pruefung.
    veralteterStand() { return this.settlement && this.settlement.stale && !this.belegsumme; },
  },
  methods: {
    betrag(minor) {
      const stellen = Number.isInteger(this.settlement.minorUnit) ? this.settlement.minorUnit : 2;
      return (Number(minor || 0) / (10 ** stellen)).toLocaleString('de-DE', {
        style: 'currency', currency: this.settlement.currency || 'EUR',
      });
    },
    konfliktText(code) {
      const texte = {
        currency_mismatch: 'Abweichende Währung',
        bank_review_missing: 'Bankprüfung fehlt',
        ambiguous_allocation: 'Zuordnung nicht eindeutig',
        overpayment: 'Überzahlung',
        allocation_requires_review: 'Zahlungszuordnung erneut prüfen',
        credit_requires_assignment: 'Gutschrift einer Rechnung zuordnen',
        refund_exceeds_payment: 'Rückzahlung übersteigt den Zahlungseingang',
        unbilled_services: 'Leistungen noch nicht vollständig abgerechnet',
        paid_status_without_verified_coverage: 'Gespeicherter Bezahlt-Status ist nicht durch erfasste Zahlungen gedeckt',
        manual_bank_overlap: 'Manuelle Zahlung und Bankzuordnung überschneiden sich – doppelten manuellen Eintrag stornieren',
        manual_payment_target_changed: 'Rechnung nach Zahlungserfassung geändert – Zuordnung prüfen',
        stale: 'Nach Änderungen neu zu prüfen',
      };
      return texte[code] || String(code);
    },
  },
};
</script>
